import { QueryTarget } from "@/shared/domain/query";

import type { SearchTablePreferenceKey } from "./hooks/useSearchTablePreferences";

/**
 * Which per-user preferences record holds each table's settings, including
 * its default View.
 *
 * A total `Record`, not a lookup with a fallback: adding a `QueryTarget` should
 * fail the build here rather than silently default to another table's record,
 * which would cross two tables' preferences rather than report a gap.
 */
const PREFERENCE_KEY_BY_TARGET: Record<QueryTarget, SearchTablePreferenceKey> =
  {
    [QueryTarget.Collections]: "collection_search_table_preferences",
    [QueryTarget.Datasets]: "dataset_search_table_preferences",
    [QueryTarget.Devices]: "device_search_table_preferences",
    [QueryTarget.Events]: "event_search_table_preferences",
    [QueryTarget.Files]: "file_search_table_preferences",
    [QueryTarget.Sessions]: "session_search_table_preferences",
    [QueryTarget.Topics]: "topic_search_table_preferences",
    [QueryTarget.TopicMessagePaths]: "message_path_search_table_preferences",
  };

/** The preferences record for one table. */
export function searchTablePreferenceKeyFor(
  target: QueryTarget,
): SearchTablePreferenceKey {
  return PREFERENCE_KEY_BY_TARGET[target];
}
